<script>
    export let h = "0";
    export let w = "0";
</script>

<div class={`h-${h} w-${w}`}></div>
